import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { authSelector } from "../../feature/auth/authSelector";

const RedirectRoute = () => {
  const { userState } = useSelector(({ authState }) => authSelector(authState));

  if (!userState.accessToken) {
    return <Navigate to="/sign-in" />;
  }
  return userState.role === "admin" ? (
    <Navigate to="/admin/dashboard" />
  ) : (
    <Navigate to="/partner/dashboard" />
  );
};

export default RedirectRoute;
